import { types } from '../../../constants/ActionTypes'
import { getLanguageShortCode } from '../../../lib';
import { LANGUAGE_SHORT_CODE } from '../../../constants';

const initialState = {
  userProfile: undefined,
  tabId: 0,
  language: LANGUAGE_SHORT_CODE.JA,
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      return { ...state, language: getLanguageShortCode(action.payload.location.pathname) }
    case types.user.UNMOUNT:
      return { ...state, userProfile: undefined }
    case types.user.RECEIVE_USER_PROFILE:
      return { ...state, userProfile: action.userProfile }
    case types.user.CHANGED_TAB:
      return { ...state, tabId: action.tabId }
    default:
      return state
  }
}

export default user


// WEBPACK FOOTER //
// ./src/reducers/Page/User/User.js